export const ACQUISITION_METHODS_API = 'orders/acquisition-methods';
export const ACQUISITIONS_UNITS_API = 'acquisitions-units/units';
export const ACQUISITIONS_UNIT_MEMBERSHIPS_API = 'acquisitions-units/memberships';
export const AUDIT_ACQ_EVENTS_API = 'audit-data/acquisition';
export const BATCH_GROUPS_API = 'batch-groups';
export const BUDGETS_API = 'finance/budgets';
export const CAMPUSES_API = 'location-units/campuses';
export const CATEGORIES_API = 'organizations-storage/categories';
export const CONFIG_API = 'configurations/entries';
export const CONSORTIA_API = 'consortia';
export const CONSORTIA_CONSORTIUM_TENANTS_API = 'tenants';
export const CONSORTIA_USER_TENANTS_API = 'user-tenants';
export const CONSORTIUM_CAMPUSES_API = 'search/consortium/campuses';
export const CONSORTIUM_INSTITUTIONS_API = 'search/consortium/institutions';
export const CONSORTIUM_LIBRARIES_API = 'search/consortium/libraries';
export const CONSORTIUM_LOCATIONS_API = 'search/consortium/locations';
export const CONTRIBUTOR_NAME_TYPES_API = 'contributor-name-types';
export const DATA_EXPORT_CONFIGS_API = 'data-export-spring/configs';
export const EXCHANGE_RATE_API = 'finance/exchange-rate';
export const EXPENSE_CLASSES_API = 'finance/expense-classes';
export const FISCAL_YEARS_API = 'finance/fiscal-years';
export const FUNDS_API = 'finance/funds';
export const HOLDINGS_API = 'holdings-storage/holdings';
export const INSTITUTIONS_API = 'location-units/institutions';
export const INVOICES_API = 'invoice/invoices';
export const INVOICE_LINE_API = 'invoice/invoice-lines';
export const ITEMS_API = 'inventory/items';
export const IDENTIFIER_TYPES_API = 'identifier-types';
export const LIBRARIES_API = 'location-units/libraries';
export const LINES_API = 'orders/order-lines';
export const LOAN_TYPES_API = 'loan-types';
export const LOCATIONS_API = 'locations';
export const MATERIAL_TYPE_API = 'material-types';
export const ORDERS_API = 'orders/composite-orders';
export const ORDER_PIECES_API = 'orders/pieces';
export const ORDERS_STORAGE_SETTINGS_API = 'orders-storage/settings';
export const PIECES_BATCH_STATUS_API = 'orders/pieces-batch/status';
export const PREFIXES_API = 'orders/configuration/prefixes';
export const PRIVILEGED_CONTACTS_API = 'organizations-storage/privileged-contacts';
export const PUBLICATIONS_API = 'publications';
export const REQUESTS_API = 'circulation/requests';
export const RECEIVING_TITLES_API = 'orders/titles';
export const ROUTING_LIST_API = 'orders/routing-lists';
export const SEARCH_API = 'search';
export const SEND_CLAIMS_API = 'pieces/claim';
export const SUFFIXES_API = 'orders/configuration/suffixes';
export const TAGS_API = 'tags';
export const TRANSACTIONS_API = 'finance/transactions';
export const USERS_API = 'users';
export const VENDORS_API = 'organizations/organizations';
export const VOUCHERS_API = 'voucher/vouchers';
export const VOUCHER_LINES_API = 'voucher/voucher-lines';
